import React from 'react';
import { barPropTypes } from '../../model';

export const Bar = ({ className = '', height = 0, width = '' }) => (
  <div data-testid="chart-bar" className={className} style={{ height, width }} />
);

Bar.propTypes = barPropTypes;
